import {
  Box,
  BoxProps,
  Heading,
  HeadingProps,
  Stack,
  StackProps,
  forwardRef,
} from '@chakra-ui/react';
import * as React from 'react';

export const AdminPage: React.FC<BoxProps> = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};

export const AdminPageHeader: React.FC<StackProps> = ({
  children,
  ...props
}) => {
  return (
    <Stack direction="row" spacing="4" alignItems="flex-start" {...props}>
      {children}
    </Stack>
  );
};

export const AdminPageHeading: React.FC<HeadingProps> = ({
  children,
  ...props
}) => {
  return (
    <Heading size="md" {...props}>
      {children}
    </Heading>
  );
};

export const AdminPageContent = forwardRef<BoxProps, 'div'>(
  ({ children, ...props }, ref) => {
    return (
      <Box marginY="5" {...props} ref={ref}>
        {children}
      </Box>
    );
  }
);
